import { connect } from 'react-redux'
import SupplementList from 'components/supplements/SupplementList'
import { fetchSupplements } from 'actions/app'

const mapStateToProps = (state) => ({
  supplements: state.app.supplements,
})

const mapDispatchToProps = {
  fetchSupplements,
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplementList)



// WEBPACK FOOTER //
// ./src/containers/SupplementList.js